import React, { Component } from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";

import Form from "./Form";

import { Container, Header } from "semantic-ui-react";
import { Loader } from "components/Loader";
import { withApplicationId, withLanguage } from 'HOCs'


class NewContent extends Component {
  state = {
    showPreview: false,
    template: ""
  };

  renderNew() {
    return (
      <React.Fragment>
        <Header as="h1" content="New Content" />
        <Form />
      </React.Fragment>
    );
  }
  renderEdit() {
    const { match, language, applicationId, languageQuery } = this.props;

    return (
      <React.Fragment>
        <Header as="h1" content="Edit Content" />

        <Query
          query={FIND_CONTENT}
          variables={{ language, id: match.params.contentId }}
          fetchPolicy="network-only"
        >
          {({ data, loading, error }) => {
            if (loading) {
              return <Loader />;
            }
            if (error || !data) {
              this.props.history.push(`/applications/${applicationId}/contents?${languageQuery}`);
              return <p>article not found</p>;
            }
            return (
              <Form
                initialValues={data.content}
              />
            );
          }}
        </Query>
      </React.Fragment>
    );
  }

  render() {
    let editMode = this.props.location.pathname.includes("edit");
    return (
      <Container>{editMode ? this.renderEdit() : this.renderNew()}</Container>
    );
  }
}

export const FIND_CONTENT = gql`
  query FindContent($language: String!, $id: ID!) {
    content(language: $language, id: $id) {
      id
      title
      description
      imgUrl
      videoUrl
      template
      category
      categoryId
      nodeName
      applicationId
      tags {
        id
        name
      }
      sources {
        name
        url
      }
      body {
        header
        text
        imgUrl
      }
      html
    }
  }
`;

export default withApplicationId(withLanguage(NewContent));



// WEBPACK FOOTER //
// ./src/pages/Contents/New/index.js